module.exports = __webpack_public_path__ + "img/Andaluza-21-min.5e4f7afb.jpg";